import { connect } from 'react-redux'
import {
  compose, lifecycle, withHandlers, withState,
} from 'recompose'
import { message } from 'antd'
import { bindActionCreators } from 'redux'
import { updateSiteConfigs } from 'actions/Site'
import {
  fetchMenu, fetchMenuDetail, createMenu, updateMenu,
} from 'actions/Menu'
import FormMenuView from 'components/pages/menu/Form'
import history from 'utils/history'

const mapStateToProps = () => ({})

const mapDispatchToProps = dispatch => ({
  updateSiteConfigs: bindActionCreators(updateSiteConfigs, dispatch),
  fetchMenuDetail: bindActionCreators(fetchMenuDetail, dispatch),
  createMenu: bindActionCreators(createMenu, dispatch),
  updateMenu: bindActionCreators(updateMenu, dispatch),
  fetchMenu: bindActionCreators(fetchMenu, dispatch),
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('isSubmit', 'setIsSubmit', false),
  withState('isEdit', 'setIsEdit', false),
  withState('data', 'setData', {}),
  withState('menuList', 'setMenuList', {
    data: [],
    isFetching: true,
  }),
  withHandlers({
    getMenuList: props => async (params) => {
      const { setMenuList } = props
      props.fetchMenu(params)
        .then((res) => {
          setMenuList({
            data: res.data,
            isFetching: false,
          })
        })
        .catch(() => {
          setMenuList({
            data: [],
            isFetching: false,
          })
        })
    },
    getDetail: props => async (id) => {
      const { setData } = props

      try {
        const res = await props.fetchMenuDetail(id)
        setData(res)
      } catch (err) {
        setData()
      }
    },
    handleSubmit: props => (values) => {
      const payload = values

      if (!payload?.parent_id) {
        delete payload.parent_id
      }

      props.setIsSubmit(true)

      if (props.isEdit) {
        props.updateMenu(props.match.params.id, payload)
          .then(() => {
            message.success('Menu has been updated')
            props.setIsSubmit(false)
            history.push('/menu')
          })
          .catch((error) => {
            props.setIsSubmit(false)
          })
      } else {
        props.createMenu(payload)
          .then(() => {
            message.success('Menu has been created')
            props.setIsSubmit(false)
            history.push('/menu')
          })
          .catch((error) => {
            props.setIsSubmit(false)
          })
      }
    },
  }),
  lifecycle({
    componentDidMount() {
      const {
        match, setIsEdit, getMenuList, getDetail,
      } = this.props
      this.props.updateSiteConfigs({
        titlePage: 'Menu Form',
        activePage: 'menu',
        activeSubPage: 'menu',
      })

      getMenuList()

      if (match.params.id) {
        setIsEdit(true)
        getDetail(match.params.id)
      }
    },
  }),
)(FormMenuView)
